import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09a15fae")

_pushScopeId("data-v-09a15fae")
const _hoisted_1 = { class: "qbe-filter-group" }
const _hoisted_2 = {
  class: "kn-draggable",
  draggable: "false"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QBEOperator = _resolveComponent("QBEOperator")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["filter-group-container", { 'qbe-group-selected': _ctx.selected }],
      draggable: "true",
      onDragstart: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args))),
      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.select(_ctx.node)), ["stop"]))
    }, [
      _withDirectives(_createVNode("span", { class: "qbe-group-tooltip qbe-group-tooltip-top" }, _toDisplayString(_ctx.$t('qbe.advancedFilters.replaceTooltip')), 513), [
        [_vShow, _ctx.dropzoneTopVisible]
      ]),
      _createVNode("div", {
        ref: 'group-top-' + _ctx.groupId,
        class: "filter-dropzone",
        onDrop: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onDropComplete($event)), ["stop"])),
        onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.displayDropzone('top')), ["prevent"])),
        onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.hideDropzone('top')), ["prevent"]))
      }, null, 544),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_QBEOperator, {
          propNode: _ctx.node.childNodes[0],
          selected: _ctx.selected,
          onSelectedChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('selectedChanged'))),
          onTreeUpdated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('treeUpdated')))
        }, null, 8, ["propNode", "selected"])
      ]),
      _createVNode("div", {
        ref: 'group-bottom-' + _ctx.groupId,
        class: "filter-dropzone",
        onDrop: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.onDropMove($event)), ["stop"])),
        onDragover: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.displayDropzone('bottom')), ["prevent"])),
        onDragleave: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.hideDropzone('bottom')), ["prevent"]))
      }, null, 544),
      _withDirectives(_createVNode("span", { class: "qbe-group-tooltip qbe-group-tooltip-bottom" }, _toDisplayString(_ctx.$t('qbe.advancedFilters.moveTooltip')), 513), [
        [_vShow, _ctx.dropzoneBottomVisible]
      ])
    ], 34)
  ]))
})